import axios from 'axios';
import {checkErrors} from './errors';

export const LOADCATEGORIES_REQUESTED = 'categories/LOADCATEGORIES_REQUESTED';
export const LOADCATEGORIES_FINISHED = 'categories/LOADCATEGORIES_FINISHED';
export const SETCATEGORIES = 'categories/SETCATEGORIES';

export const ADDCATEGORY_REQUESTED = 'categories/ADDCATEGORY_REQUESTED';
export const ADDCATEGORY_FINISHED = 'categories/ADDCATEGORY_FINISHED';

export const EDITCATEGORY_REQUESTED = 'categories/EDITCATEGORY_REQUESTED';
export const EDITCATEGORY_FINISHED = 'categories/EDITCATEGORY_FINISHED';

export const REMOVECATEGORY_REQUESTED = 'categories/REMOVECATEGORY_REQUESTED';
export const REMOVECATEGORY = 'categories/REMOVECATEGORY';
export const REMOVECATEGORY_FINISHED = 'categories/REMOVECATEGORY_FINISHED';

export const LOADCATEGORY_REQUESTED = 'categories/LOADCATEGORY_REQUESTED';
export const LOADCATEGORY_FINISHED = 'categories/LOADCATEGORY_FINISHED';

const initialState = {
  categories: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingCategories: false,
  isAddingCategory: false,
  isEditingCategory: false,
  isRemovingCategory: false,
  isLoadingCategory: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADCATEGORIES_REQUESTED:
    return {
      ...state,
      isLoadingCategories: true
    };

  case LOADCATEGORIES_FINISHED:
    return {
      ...state,
      isLoadingCategories: false
    };

  case SETCATEGORIES:
    
    return {
      ...state,
      categories: action.categories
    };
  
  case ADDCATEGORY_REQUESTED:
    return {
      ...state,
      isAddingCategory: true
    };

  case ADDCATEGORY_FINISHED:
    return {
      ...state,
      isAddingCategory: false
    };
  
  case EDITCATEGORY_REQUESTED:
    return {
      ...state,
      isEditingCategory: true
    };

  case EDITCATEGORY_FINISHED:
    return {
      ...state,
      isEditingCategory: false
    };

  case REMOVECATEGORY:
    return {
      ...state,
      categories: action.categories
    };

  case REMOVECATEGORY_REQUESTED:
    return {
      ...state,
      isRemovingCategory: true,
    };

  case REMOVECATEGORY_FINISHED:
    return {
      ...state,
      isRemovingCategory: false
    };
  
  case LOADCATEGORY_REQUESTED:
    return {
      ...state,
      isLoadingCategory: true
    };

  case LOADCATEGORY_FINISHED:
    return {
      ...state,
      isLoadingCategory: false
    };
  
  default:
    return state;
  }
};


export const loadCategories = () => {
  return (dispatch, getState) => {

    const categoriesState = getState().categories;

    dispatch({
      type: LOADCATEGORIES_REQUESTED
    });

    axios.get(`${window.endpoint}/categories?limit=${categoriesState.limit}&skip=${categoriesState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETCATEGORIES,
        categories: response.data.categories
      });

      dispatch({
        type: LOADCATEGORIES_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addCategory = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDCATEGORY_REQUESTED
    });

    axios.post(`${window.endpoint}/categories`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDCATEGORY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editCategory = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITCATEGORY_REQUESTED
    });

    axios.post(`${window.endpoint}/categories/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITCATEGORY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCategory = (id, cb) => {
  return (dispatch, getState) => {

    const categoriesState = getState().categories;

    dispatch({
      type: REMOVECATEGORY_FINISHED
    });

    axios.delete(`${window.endpoint}/categories/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVECATEGORY,
        categories: categoriesState.categories.filter((category) => category.category_id !== id)
      });
      
      dispatch({
        type: REMOVECATEGORY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadCategory = (category_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADCATEGORIES_REQUESTED
    });

    axios.get(`${window.endpoint}/categories/${category_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADCATEGORIES_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories.js